import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { LoadingService } from './loading.service';
import { tap } from 'rxjs/operators';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class DonorService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private loadingService: LoadingService,
  ) { }

  search(value, searchType) {
    const SEARCH_BY_EMAIL    = 0
    const SEARCH_BY_NAME     = 1
    let params = {}

    if(searchType = 1) {
      params = {
        "searchType" : SEARCH_BY_NAME,
        "email"      : "",
        "name"       : value
      } 
    } 

    if(searchType = 0) {
      params = {
        "searchType" : SEARCH_BY_EMAIL,
        "email"      : value,
        "name"       : ""
      }
    } 

    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `p=${encodeURIComponent(JSON.stringify(params))}`,
      `access_token=${token}`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/donorSearch', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));
  }
}